import { Directive, forwardRef, Renderer2, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const VIN_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => VinInputDirective),
    multi: true
};

@Directive({
    selector: '[vin]',
    host: {
        '(input)': 'onInput($event.target.value)',
        '(blur)': 'onBlur()'
    },
    providers: [VIN_VALUE_ACCESSOR]
})
export class VinInputDirective implements ControlValueAccessor {

    private readonly validChars = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0',
                                   'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

    constructor(private renderer: Renderer2, private elementRef: ElementRef) {
    }

    public onChange = (_: any) => {};

    public onTouched = () => {};

    public registerOnChange(fn: (value: any) => any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => any): void {
        this.onTouched = fn;
    }

    public onBlur() {
        this.onTouched();
    }

    public onInput(value: string) {
        const formatted: any = this.formatValue(value);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', formatted);
        this.onChange(formatted);
    }

    public writeValue(value: any): void {
        const formatted: any = this.formatValue(value);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', formatted);
    }

    private formatValue(value: any): string {
        return value && typeof value === 'string' ?
            this.validateChars(value.toUpperCase()) :
            '';
    }

    private validateChars(input: string): string {

        const inputValue = input.split('');

        for (let i = (inputValue.length - 1); i > -1; i--) {
            const val = inputValue[i];
            if (this.validChars.indexOf(val) === -1) {
                if (val === 'I') {
                    inputValue[i] = 'L';
                } else if (val === 'O' || val === 'Q') {
                    inputValue[i] = '0';
                } else {
                    inputValue.splice(i, 1);
                }
            }
        }

        return inputValue.join('');
    }
}
